export const countFormatter = (value, t) => {

  return `${t("charactersLeft", { ns: "CreateExhibitionPanel" })} ${Number(value.maxLength) - Number(value.count)}`;
};
